<payee-icon
  name="info-grey-outline"
  width="24"
  height="24"
></payee-icon>
<div class="input-label-small">
  <ng-content></ng-content>
</div>
